import { LeadStatus } from 'models/Lead';

export const leadStatusOptions = (isPersonalLead = false) => {
  return [
    { label: 'All', value: 'TOTAL' },
    ...(!isPersonalLead
      ? [{ label: 'No Lead', value: LeadStatus.NO_LEAD }]
      : []),
    { label: 'Pending', value: LeadStatus.PENDING },
    { label: 'Declined', value: LeadStatus.DECLINED },
    { label: 'Saved', value: LeadStatus.SAVED },
    { label: 'Confirmed', value: LeadStatus.CONFIRMED },
  ] as const;
};
